/**
 * Where a notification leads in the admin, read off its correlation tags.
 * Null when it leads nowhere.
 *
 * Shared so the admin's bell / popup and the API's phone push open the same
 * page for the same notification.
 *
 * Bookings first: a booking notification also carries `customerId` when the
 * guest matched a customer profile, and opening the customer instead of the
 * booking is exactly the wrong page for "top up the wallet and press Book".
 */
export function notificationTargetPath(
  tags: Readonly<Record<string, string>> | null | undefined,
): string | null {
  const bookingId = tags?.bookingId;
  // A settled cancellation opens the booking with its cancellation summary
  // on top - guest name, what they paid, what the supplier kept, what to
  // refund - and a "Refund now" button. The detail page reads the flag.
  if (bookingId)
    return tags?.moment === 'cancelled'
      ? `/bookings/${bookingId}?notice=cancelled`
      : `/bookings/${bookingId}`;
  // Operations notices (assigned, held, fund paid, approvals...) open the
  // converted lead's booking sheet, not the sales lead page: that is where
  // the hold is cross-checked and fund asked, and ops users may not even
  // have access to the lead.
  const opsCaseId = tags?.opsCaseId;
  if (opsCaseId) return `/operations/converted-leads/${opsCaseId}`;
  const leadId = tags?.leadId;
  if (leadId) return `/leads/${leadId}`;
  const customerId = tags?.customerId;
  if (customerId) return `/customers/${customerId}`;
  return null;
}
